export default function postGenerateCustomSslReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'POST_CUSTOM_GENERATE_SSL_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'POST_CUSTOM_GENERATE_SSL_ERROR':
      return {...state, ...{error: action.error}};

    case 'POST_CUSTOM_GENERATE_SSL_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}